import React, { Component } from "react";
import { NavLink, Link, withRouter } from "react-router-dom";
import "../style/navigation.scss";
import M from "materialize-css";
import logo from "../images/logo.png";

export default withRouter(
  class Navigation extends Component {
    handleClick = (e) => {
      let sideNav = document.querySelector(".sidenav");
      let instance = M.Sidenav.getInstance(sideNav);
      instance.close();
    };

    render() {
      return (
        <div className="nav">
          <nav>
            <div className="nav-wrapper white">
              <NavLink exact to="/" activeClassName="" className="brand-logo">
                <img src={logo} alt="The logo of the Rounders League" />
              </NavLink>
              <a href="#" data-target="mobile-demo" className="sidenav-trigger">
                <i className="material-icons">menu</i>
              </a>
              <ul className="right hide-on-med-and-down navList">
                <li>
                  <NavLink activeClassName="active" exact to="/">
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="active" to="/fixtures">
                    Fixtures
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="active" to="/documents">
                    Documents
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="active" to="/committee">
                    Committee
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="active" to="/contact">
                    Contact
                  </NavLink>
                </li>
                {/* <li><NavLink activeClassName="active" to="/news">News</NavLink></li> */}
                <li>
                  <NavLink activeClassName="active" to="/gallery">
                    Gallery
                  </NavLink>
                </li>
              </ul>
            </div>
          </nav>

          <ul className="sidenav" id="mobile-demo" onClick={this.handleClick}>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/fixtures">Fixtures</Link>
            </li>
            <li>
              <Link to="/documents">Documents</Link>
            </li>
            <li>
              <Link to="/committee">Committee</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            {/* <li><Link to="/news">News</Link></li> */}
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
          </ul>
        </div>
      );
    }
  }
);
